import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, MenuItem, Typography } from "@mui/material";
import FormComponent from "../../../components/gernerateForm/FormComponent";
import generateFormSubmissionOnline from "./form-submission/dataFormGenerate.data";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonBack,
  ButtonDel,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { FiberManualRecord, FileDownloadOutlined } from "@mui/icons-material";
import { alertSuccess, swalConfirm } from "../../../components/alert/swal";
import CustomStatus from "../../../components/chip/CustomStatus";
import {
  handleColorStatusUtil,
  handleTextStatusUtil,
} from "../../../utils/statusLeaveRequest";
import { useParams } from "react-router-dom";
import { calculateLeavePeriod } from "../../../utils/calculatePeriod";
import { OnlineLeaveSubmissionApi } from "../../../api/online-leave-submission/online-leave-submission.api";
import ModalConfirmApprove from "./components/modal/ModalApproveRequest";
import { leaveTypeApi } from "../../../api/leave-type/leave-type.api";
import moment from "moment";
import InputTextField from "../../../components/input/inputTextField";
import FilterSelect from "../../../components/select/filterSelect";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import InputDatePicker from "../../../components/input/inputDatePicker";
import Form01 from "../online-leave-submission/form-submission/form/Form01";
import Form02 from "../online-leave-submission/form-submission/form/Form02";
import Form03 from "../online-leave-submission/form-submission/form/Form03";
import Form04 from "../online-leave-submission/form-submission/form/Form04";
import Form05 from "../online-leave-submission/form-submission/form/Form05";
import Form07 from "../online-leave-submission/form-submission/form/Form07";
import Form10 from "../online-leave-submission/form-submission/form/Form10";
import Form11 from "../online-leave-submission/form-submission/form/Form11";
import UploadFile from "../../../components/upload/UploadFile";
import { FontBackgroundColor } from "ckeditor5";
import Form06 from "../online-leave-submission/form-submission/form/Form06";
import Form08 from "../online-leave-submission/form-submission/form/Form08";
import Form09 from "../online-leave-submission/form-submission/form/Form09";
import { saveAs } from "file-saver";
import { getFileExtension } from "../../../utils/fileTypeDownload";

type Props = {};

interface LeaveType {
  id_leave_type: number;
  id_leave_form: number;
  leave_type_name: string;
  is_accumulate: string;
  id_employee_inspector: number;
  id_employee_approve: number;
  status: string;
  created_id: number;
  created_date: string;
  modified_id: number;
  modified_date: string;
  leave_form: {
    json: string;
  };
}

const OnlineLeaveSubmissionApprove: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { profile } = useSelector((state: any) => state.profile);
  const leaveRequestId = id ? parseInt(id) : 0;

  const [isCanEdit, setIsCanEdit] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;

  const [mainInputValue, setMainInputValue] = useState({
    information: {
      leave_id: 0,
      id_employee: 0,
      employee_no: "",
      title: "",
      first_name: "",
      last_name: "",
      buddhist_name: "",
      leave_type_id: 0,
      leave_form_no: "",
      leave_peroid_date: [],
      leave_status: "",
      quit_date: "",
      leave_day: 0,
      worship: "",
    },
  });

  const [commentApprove, setCommentApprove] = useState({
    comment: "",
  });
  const [dataDetail, setDataDetail] = useState<any>(null);

  const [customCommentApprove, setCustomCommentApprove] = useState({
    emp_before_start_work: "",
    assignment_international_type_2: "",
    perform_type_2_work: "",
    does_university_plans: "",
    beneficial_thailand: "",
  });

  const [dataJson, setDataJson] = useState("");
  const [idEmployeeApproveFirst, setIdEmployeeApproveFirst] = useState(0);
  const [idEmployeeApproveSecond, setIdEmployeeApproveSecond] = useState(0);
  const [idEmployeeApproveThird, setIdEmployeeApproveThird] = useState(0);

  const [isShowModalApprove, setIsShowModalApprove] = useState<boolean>(false);
  const [titleModal, setTitleModal] = useState<string>("approve");

  const [isValidateForm, setIsValidateForm] = useState(false);
  const [documentUpload, setDocumentUpload] = useState([]);
  const [actionsAllowed, setActionsAllowed] = useState<string[]>([]);

  const [dataLeaveType, setDataLeaveType] = useState<LeaveType[]>([]);

  const getLeaveType = async () => {
    const param = { limit: 100 };
    const res = await leaveTypeApi.getAllLeaveType(param);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveType(data.data.items);
    } else {
      setDataLeaveType([]);
    }
  };

  useEffect(() => {
    getLeaveType();
  }, []);

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const getLeaveRequestDetail = async (leave_id: number) => {
    try {
      const res =
        await OnlineLeaveSubmissionApi.getSingleRequestLeaveSubmission(
          leave_id
        );
      const data = res.data;

      if (data.status < 300 && data.data) {
        const { data: leaveData } = data;

        const newDataDetail = leaveData.leave_detail
          ? JSON.parse(leaveData.leave_detail)
          : "";
        setDataDetail(data?.data);
        const newData = {
          leave_id: leaveData.id_leave,
          id_employee: leaveData.employee.id_employee,
          employee_no: leaveData.employee.employee_no,
          title: leaveData.employee.title,
          first_name: leaveData.employee.first_name,
          last_name: leaveData.employee.last_name,
          buddhist_name: leaveData.employee.buddhist_name,
          leave_type_id: leaveData.id_leave_type,
          leave_form_no:
            leaveData.leave_type.id_leave_form &&
              leaveData.leave_type.id_leave_form < 10
              ? "0" + leaveData.leave_type.id_leave_form.toString()
              : leaveData.leave_type.id_leave_form.toString(),
          leave_peroid_date: [
            moment(leaveData.leave_start_date).format("YYYY-MM-DD"),
            moment(leaveData.leave_end_date).format("YYYY-MM-DD"),
          ],
          quit_date: newDataDetail.main?.quit_date ?? "",
          leave_day: calculateLeavePeriod(
            leaveData.leave_start_date,
            leaveData.leave_end_date
          ),
          leave_status: leaveData.leave_status,
          worship: newDataDetail.main?.worship ?? "",
        };
        // Update state with the new data
        setMainInputValue({
          information: newData as any,
        });
        setDataJson(newDataDetail ?? {});
        setIdEmployeeApproveFirst(leaveData.leave_approve_first ?? 0);
        setIdEmployeeApproveSecond(leaveData.leave_approve_second ?? 0);
        setIdEmployeeApproveThird(leaveData.leave_approve_third ?? 0);
        setDocumentUpload(leaveData.leave_file);

        // console.log("leaveData.leave_approve_first_comment", leaveData);
        if (
          leaveData.leave_status === "approve third" ||
          leaveData.leave_status === "not approve third"
        ) {
          setCommentApprove({
            comment: leaveData.leave_approve_third_comment,
          });
        } else if (
          leaveData.leave_status === "approve second" ||
          leaveData.leave_status === "not approve second"
        ) {
          setCommentApprove({
            comment: leaveData.leave_approve_second_comment,
          });
        } else if (
          leaveData.leave_status === "approve first" ||
          leaveData.leave_status === "not approve first"
        ) {
          setCommentApprove({
            comment: leaveData.leave_approve_first_comment,
          });
        } else {
          setCommentApprove({
            comment: "",
          });
        }
      } else {
      }
    } catch (error) {
      console.error("Error fetching leave request details:", error);
    }
  };

  useEffect(() => {
    const { leave_peroid_date } = mainInputValue.information;

    if (leave_peroid_date[0] && leave_peroid_date[1]) {
      const leaveDays = calculateLeavePeriod(
        leave_peroid_date[0],
        leave_peroid_date[1]
      );

      setMainInputValue((prevState) => ({
        information: {
          ...prevState.information,
          leave_day: leaveDays,
        },
      }));
    }
  }, [mainInputValue.information.leave_peroid_date]);

  useEffect(() => {
    if (leaveRequestId) {
      getLeaveRequestDetail(leaveRequestId);
    }
  }, [leaveRequestId]);

  const handleDeleteFile = async (leave_id: number, id_leave_file: number) => {
    console.log("delete file");
  };

  const handleChangePeriodLeave = (value: any) => {
    setMainInputValue({
      information: {
        ...mainInputValue.information,
        leave_peroid_date: value,
      },
    });
  };

  const handleClearPeriodLeave = () => {
    setMainInputValue({
      information: {
        ...mainInputValue.information,
        leave_peroid_date: [],
      },
    });
  };

  useEffect(() => {
    if (
      mainInputValue.information.leave_status === "wait" &&
      profile.id_employee === idEmployeeApproveFirst
    ) {
      setActionsAllowed(["approve first", "not approve first"]);
    } else if (
      mainInputValue.information.leave_status === "approve first" &&
      profile.id_employee === idEmployeeApproveSecond
    ) {
      setActionsAllowed(["approve second", "not approve second"]);
    } else if (
      mainInputValue.information.leave_status === "approve second" &&
      profile.id_employee === idEmployeeApproveThird
    ) {
      setActionsAllowed(["approve third", "not approve third"]);
    } else {
      setActionsAllowed([]);
    }
  }, [
    mainInputValue.information.leave_status,
    profile,
    idEmployeeApproveFirst,
    idEmployeeApproveSecond,
    idEmployeeApproveThird,
  ]);

  const handleDownloadFile = async (
    leave_id: number,
    id_leave_file: number,
    export_type: string
  ) => {
    let query: any = {
      type: export_type,
    };
    dispatch(setLoading());
    await OnlineLeaveSubmissionApi.GetFileByIdLeaveFile(query, id_leave_file)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `attachment-leave-request-${new Date().getTime()}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  // console.log(dataDetail?.leave_period?.id_leave_period,'dataDetail?.leave_period?.id_leave_period')


  
  return (
    <>
      <ModalConfirmApprove
        title={titleModal}
        setIsOpenModal={(isOpen: boolean) => setIsShowModalApprove(isOpen)}
        isOpenModal={isShowModalApprove}
        commentApprove={commentApprove}
        setCommentApprove={setCommentApprove}
        actionsAllowed={actionsAllowed}
        id_leave_period={dataDetail?.leave_period?.id_leave_period}
        onFetch={() => {
          getLeaveRequestDetail(leaveRequestId);
        }}
        form_id={mainInputValue.information.leave_form_no}
        customCommentApprove={customCommentApprove}
        setCustomCommentApprove={setCustomCommentApprove}
      />

      <div className="h-auto">
        <NavigateListCustom
          navigateData={[
            {
              name: t(
                "MANAGE_ONLINE_LEAVE_SUBMISSION.COMMON.BREADCRUMB.ONLINE_LEAVE_SUBMISSION_SYSTEM"
              ),
              key: "1",
              pathName: routeName.cms.OnlineLeaveSubmissionRequest,
            },
            {
              name: t(
                "MANAGE_ONLINE_LEAVE_SUBMISSION.COMMON.BREADCRUMB.ONLINE_LEAVE_SUBMISSION"
              ),
              key: "2",
              pathName: pathname
            },
          ]}
        />
        {/* header */}
        <section className="my-4">
          <Typography variant="h3">
            {t(
              "MANAGE_ONLINE_LEAVE_SUBMISSION.TOPIC.SUB_ONLINE_LEAVE_SUBMISSION"
            )}
          </Typography>
          <CustomStatus
            label={handleTextStatusUtil(
              mainInputValue.information.leave_status
            )}
            type="outlined"
            color={handleColorStatusUtil(
              mainInputValue.information.leave_status
            )}
            icon={<FiberManualRecord />}
            width="250px"
          />
        </section>

        <section className="w-full grid grid-cols-12 gap-4 mt-[40px]">
          {commentApprove.comment ? (
            <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
              <InputTextField
                heading={"ความคิดเห็นผู้บังคับบัญชา"}
                value={commentApprove.comment ?? ""}
                disabled={false}
                row={3}
                maxRows={5}
                disablePaddingMultiline
                multiline
                inputHeight={"auto"}
                borderColor={
                  handleColorStatusUtil(
                    mainInputValue.information.leave_status
                  ) === "error"
                    ? "red"
                    : "green"
                }
              />
            </article>
          ) : null}

          <article className="w-full col-span-12 lg:col-span-2 md:col-span-6 sm:col-span-12">
            <InputTextField
              heading={t("ONLINE_LEAVE_SUBMISSION.FORM.PREFIX_LABEL")}
              value={mainInputValue.information.title ?? ""}
              disabled={!isCanEdit}
            />
          </article>
          <article className="w-full col-span-12 lg:col-span-4 md:col-span-6 sm:col-span-12">
            <InputTextField
              heading={t("ONLINE_LEAVE_SUBMISSION.FORM.FIRST_NAME_LABEL")}
              value={mainInputValue.information.first_name ?? ""}
              disabled={!isCanEdit}
            />
          </article>
          <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
            <InputTextField
              heading={t("ONLINE_LEAVE_SUBMISSION.FORM.LAST_NAME_LABEL")}
              value={mainInputValue.information.last_name ?? ""}
              disabled={!isCanEdit}
            />
          </article>
          <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
            <InputTextField
              heading={t("ONLINE_LEAVE_SUBMISSION.FORM.NICKNAME_LABEL")}
              value={mainInputValue.information.buddhist_name ?? ""}
              disabled={!isCanEdit}
            />
          </article>
          <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
            <FilterSelect
              heading={t("ONLINE_LEAVE_SUBMISSION.FORM.LEAVE_TYPE_LABEL")}
              value={mainInputValue.information.leave_type_id}
              disabled={!isCanEdit}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const selectedOption = dataLeaveType.find(
                  (option: any) =>
                    option.id_leave_type === parseInt(e.target.value)
                );
                if (selectedOption) {
                  setIdEmployeeApproveSecond(
                    selectedOption.id_employee_approve
                  );
                  setIdEmployeeApproveThird(
                    selectedOption.id_employee_inspector
                  );
                  setMainInputValue({
                    information: {
                      ...mainInputValue.information,
                      leave_type_id: selectedOption?.id_leave_type || 0,
                      leave_form_no: selectedOption?.leave_form.json || "",
                      leave_peroid_date: [],
                      leave_day: 0,
                      worship: "",
                    },
                  });
                  setDataJson("");
                }
              }}
              options={dataLeaveType.map((option: any) => (
                <MenuItem
                  value={option.id_leave_type}
                  key={option.id_leave_type}
                >
                  {option.leave_type_name}
                </MenuItem>
              ))}
              labelId={""}
              selectId={""}
            />
          </article>

          {mainInputValue.information.leave_type_id &&
            mainInputValue.information.leave_form_no ? (
            <>
              {mainInputValue.information.leave_form_no === "01" ||
                mainInputValue.information.leave_form_no === "02" ||
                mainInputValue.information.leave_form_no === "03" ||
                mainInputValue.information.leave_form_no === "04" ||
                mainInputValue.information.leave_form_no === "05" ||
                mainInputValue.information.leave_form_no === "06" ? (
                <>
                  <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                    <InputNewRangePicker
                      heading={t(
                        "ONLINE_LEAVE_SUBMISSION.FORM.PEROID_LEAVE_START_DATE_LABEL"
                      )}
                      value={mainInputValue.information.leave_peroid_date}
                      onchange={handleChangePeriodLeave}
                      onClear={handleClearPeriodLeave}
                      allowClear
                      disabled={!isCanEdit}
                    />
                  </article>

                  <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                    <InputTextField
                      heading={t(
                        "ONLINE_LEAVE_SUBMISSION.FORM.LEAVE_AMOUNT_DATE_LABEL"
                      )}
                      value={mainInputValue.information.leave_day ?? ""}
                      disabled={!isCanEdit}
                    />
                  </article>

                  <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                    <InputTextField
                      heading={t(
                        "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_LABEL"
                      )}
                      placeholder={t(
                        "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_PLACEHOLDER"
                      )}
                      value={mainInputValue.information.worship ?? ""}
                      onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setMainInputValue({
                          information: {
                            ...mainInputValue.information,
                            worship: e.target.value,
                          },
                        })
                      }
                      disabled={!isCanEdit}
                    />
                  </article>
                </>
              ) : null}

              {mainInputValue.information.leave_form_no === "07" ? (
                <>
                  <article className="w-full col-span-12 lg:col-span-3 md:col-span-12 sm:col-span-12">
                    <InputDatePicker
                      heading={"ขอลาออกตั้งแต่วันที่"}
                      value={mainInputValue.information.quit_date ?? ""}
                      onChange={(e: any) =>
                        setMainInputValue({
                          information: {
                            ...mainInputValue.information,
                            quit_date: moment(e).format("YYYY-MM-DD"),
                          },
                        })
                      }
                      disabled={!isCanEdit}
                    />
                  </article>
                </>
              ) : null}

              {mainInputValue.information.leave_form_no === "08" ||
                mainInputValue.information.leave_form_no === "09" ||
                mainInputValue.information.leave_form_no === "10" ||
                mainInputValue.information.leave_form_no === "11" ? (
                <>
                  <article className="w-full col-span-12 lg:col-span-9 md:col-span-12 sm:col-span-12">
                    <InputTextField
                      heading={t(
                        "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_LABEL"
                      )}
                      placeholder={t(
                        "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_PLACEHOLDER"
                      )}
                      value={mainInputValue.information.worship ?? ""}
                      onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setMainInputValue({
                          information: {
                            ...mainInputValue.information,
                            worship: e.target.value,
                          },
                        })
                      }
                      disabled={!isCanEdit}
                    />
                  </article>
                </>
              ) : null}
            </>
          ) : null}
        </section>

        <section className="w-full col-span-12 lg:col-span-12 md:col-span-6 sm:col-span-12 mt-4">
          {mainInputValue.information.leave_type_id &&
            mainInputValue.information.leave_form_no ? (
            <>
              {mainInputValue.information.leave_form_no === "01" ? (
                <>
                  <Form01
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "02" ? (
                <>
                  <Form02
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "03" ? (
                <>
                  <Form03
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "04" ? (
                <>
                  <Form04
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "05" ? (
                <>
                  <Form05
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "06" ? (
                <>
                  <Form06
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "07" ? (
                <>
                  <Form07
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "08" ? (
                <>
                  <Form08
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "09" ? (
                <>
                  <Form09
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "10" ? (
                <>
                  <Form10
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
              {mainInputValue.information.leave_form_no === "11" ? (
                <>
                  <Form11
                    onSubmit={(value) => {
                      console.log("submit", value);
                    }}
                    isValidateForm={isValidateForm}
                    data={dataJson}
                    setData={setDataJson}
                    mainInputValue={mainInputValue}
                    isValudateFile={false}
                    isCanEdit={isCanEdit}
                  />
                </>
              ) : null}
            </>
          ) : null}
        </section>

        <section className="w-full my-2 gap-4 mt-4">
          {documentUpload && documentUpload.length > 0
            ? documentUpload.map((item: any, index) => {
              return (
                <div
                  key={index + 1}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <UploadFile
                    fileAttachmentId={item.id_leave_file}
                    fileAttachmentName={item.file_name}
                    noClick={item.id_leave_file ?? true}
                    onDeleteFile={() => { }}
                    // helperText={item?.id_leave_file}
                    onDrop={() => { }}
                    // file={item?.file_path}
                    formatText={t("FILE_UPLOAD.FILE_SIZE")}
                    disableDeleteFileId={true}
                    onDeleteFileId={() => {
                      handleDeleteFile(item.id_leave, item.id_leave_file);
                    }}
                    hiddenDownloadFile={false}
                    onDownloadFile={() => {
                      handleDownloadFile(
                        item.id_leave,
                        item.id_leave_file,
                        "pdf"
                      );
                    }}
                  />
                </div>
              );
            })
            : null}
        </section>

        <section className="w-full my-8 flex flex-wrap justify-center items-center gap-4">
          <ButtonBack
            onClick={() => {
              navigate(routeName.cms.OnlineLeaveSubmissionRequest);
            }}
            buttonName={t(
              "MANAGE_ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.CANCEL"
            )}
            btnProps={{
              width: "150px",
            }}
          />

          {actionsAllowed && actionsAllowed.length > 0 ? (
            <>
              <ButtonPrimary
                onClick={() => {
                  setTitleModal("approve");
                  setIsShowModalApprove(true);
                }}
                buttonName={t("อนุมัติ")}
                btnProps={{
                  width: "150px",
                }}
                mode="next"
              />

              <ButtonDel
                onClick={() => {
                  setTitleModal("reject");
                  setIsShowModalApprove(true);
                }}
                buttonName={t("ไม่อนุมัติ")}
                btnProps={{
                  width: "150px",
                }}
              />
            </>
          ) : null}
        </section>
      </div>
    </>
  );
};

export default OnlineLeaveSubmissionApprove;
